module.exports = __webpack_public_path__ + "f2ac965f8e222d645ef9a90071b56c37.svg";